import { IDataHandler } from '../IDataHandler';
import { AdTrackingEventName, allTrackingEvents, ResourceTrackingEventName } from '../TrackingEvent';
import { AdDataSet } from '../DataSet/Ad';

type aDataSetKey = keyof AdDataSet;

export const AdDataMap: Map<allTrackingEvents, aDataSetKey[]> = new Map<allTrackingEvents, aDataSetKey[]>([
    [ResourceTrackingEventName.resource, ['adID']],
    [
        AdTrackingEventName.adShow,
        [
            'adType',
            'placementID',
            'adProvider',
            'adRequestTimeMs',
            'adSdkVersion',
            'adName',
            'adWaterfallIndex',
            'adGameArea',
            'adRewardType',
            'adContext',
            'adID',
            'adError',
            'adLevelNum',
            'adSuccess',
        ],
    ],
    [
        AdTrackingEventName.adRequest,
        [
            'adType',
            'placementID',
            'adName',
            'adProvider',
            'adGameArea',
            'adRewardType',
            'adSdkVersion',
            'adContext',
            'adID',
            'adError',
            'adLevelNum',
            'adWaterfallIndex',
        ],
    ],
]);

export class AdDataHandler implements IDataHandler<AdDataSet> {
    public data: AdDataSet = new AdDataSet();

    public getEventData(eventName: AdTrackingEventName): AdDataSet {
        if (!AdDataMap.has(eventName)) return;
        const data = AdDataMap.get(eventName).reduce((acc, key) => {
            acc[key] = this.data[key] as never;
            return acc;
        }, {} as AdDataSet);

        // Reset mission data.
        if (eventName === AdTrackingEventName.adShow) {
            this.data = new AdDataSet();
        }

        return data;
    }
    public clearData(): void {
        this.data = new AdDataSet();
    }
}
